module.exports = __webpack_public_path__ + "static/media/vana_boya.34140b0f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/sales/vana_boya.jpg
// module id = 238
// module chunks = 0